import { z } from 'zod/v4';

export const ProfileSchema = z
  .object({
    id: z.string(),
    email: z.string(),
    emailVerified: z.boolean().optional(),
    twoFactorEnabled: z.boolean().optional(),
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string().nullable().optional(),
    avatarUrl: z.string().nullable().optional(),
    bio: z.string().nullable().optional(),
    locale: z.string(),
    timezone: z.string(),
    privacy: z.record(z.string(), z.string()).optional(),
    professional: z
      .object({
        headline: z.string().nullable().optional(),
        skills: z.string().nullable().optional(),
        experience: z.string().nullable().optional(),
        education: z.string().nullable().optional(),
        location: z.string().nullable().optional(),
        portfolioUrl: z.string().nullable().optional(),
        desiredRole: z.string().nullable().optional(),
        published: z.boolean().optional(),
      })
      .optional(),
    resume: z
      .object({
        filename: z.string().nullable().optional(),
        uploadedAt: z.string().nullable().optional(),
        downloadUrl: z.string().nullable().optional(),
      })
      .nullable()
      .optional(),
  })
  .passthrough();

export type Profile = z.infer<typeof ProfileSchema>;

export const UpdateProfileSchema = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phone: z.string().nullable().optional(),
  bio: z.string().nullable().optional(),
  locale: z.string().optional(),
  timezone: z.string().optional(),
  privacy: z.record(z.string(), z.string()).optional(),
  professional: z
    .object({
      headline: z.string().nullable().optional(),
      skills: z.string().nullable().optional(),
      experience: z.string().nullable().optional(),
      education: z.string().nullable().optional(),
      location: z.string().nullable().optional(),
      portfolioUrl: z.string().nullable().optional(),
      desiredRole: z.string().nullable().optional(),
      published: z.boolean().optional(),
    })
    .optional(),
});

export type UpdateProfile = z.infer<typeof UpdateProfileSchema>;
